export const BLOCK_CONSTS = {
    GET_BLOCK_BY_ID: "GET_BLOCK_BY_ID",
};
